<div id="plant-water-stress">
  @if (!loading) {
    <p>{{ 'doktar_app.services.crop_monitoring.water_stress_chart_title' | translate }}</p>
    @if (data?.length > 0) {
      <div echarts [options]="chartOption" class="chart" style="height: 150px"></div>
      <div class="d-flex gap-1 justify-content-end align-items-center">
        <span class="title">{{ 'doktar_app.services.crop_monitoring.water_stress_chart_caption' | translate }}</span>
        <span class="date">({{ lastValue?.date | luxonFormat:'d MMMM y': ('UTC'+ plantationService.selectedPlantation?.offSet) }})</span>
        <span class="value">{{ lastValue?.ndmiAverangeValue?.toFixed(2) }}</span>
      </div>
    } @else {
      <app-no-analysis [selectedDay]="selectedDay" />
    }
  } @else {
    <p-skeleton width="25rem" height="2rem" styleClass="mb-3" />
    <p-skeleton styleClass="mb-3" height="10rem" />
  }
</div>
